import filterLayoutToVisibleFromSchema from './recordCompareFilterLayoutToVisibleFromSchema';
function getUiSchemaLength(record) {
  var uiSchema = record.uiSchema;
  return uiSchema && uiSchema['dm:layout'] ? uiSchema['dm:layout'].length : 0;
}

// PRO-9203:
// Sometimes "JOURNAL" will be filtered out if "not in list" is selected.
// This is to make sure we include it, if any record has it.
export function getRecordWithLongestUiSchema(records) {
  var record = records[0];
  for (var i = 1; i < records.length; i++) {
    var current = records[i];
    if (getUiSchemaLength(current) > getUiSchemaLength(record)) {
      record = current;
    }
  }
  return record;
}
export function getChildRecord(record, property) {
  var uiSchema = record.uiSchema[property];
  var schema = record.schema.properties[property];
  if (!uiSchema) {
    return Object.assign({}, record, {
      uiSchema: {},
      schema: schema,
      data: {},
      layout: []
    });
  }
  return Object.assign({}, record, {
    uiSchema: uiSchema,
    schema: schema,
    data: record.data[property] || {},
    layout: filterLayoutToVisibleFromSchema(uiSchema['dm:layout'], schema)
  });
}
function getSchemaProperty(property, record) {
  var found = record && record.layout.find(function (item) {
    return item.id === property;
  });
  return found ? record.schema.properties[property] : undefined;
}
export function findSchemaProperty(property, type, mergeRecord, records) {
  if ('group' === type) {
    return [true, 'group'];
  }
  var selectable = true;
  var prop = getSchemaProperty(property, mergeRecord);
  if (!prop) {
    selectable = false;
    prop = getSchemaProperty(property, records.find(function (record) {
      return !!getSchemaProperty(property, record);
    }));
  }
  return [selectable, prop.type === 'object' ? 'object' : type];
}
export function getChildLayout(layout, property) {
  return layout.find(function (item) {
    return item.id === property;
  }).children;
}
export function getChildLayoutRecord(record, property) {
  return Object.assign({}, record, {
    layout: getChildLayout(record.layout, property)
  });
}

// Needed for build
export default {};